import React, { useEffect, useState } from 'react';
import Loader from 'components/Loader';
import PubSub from 'services/PubSub/';
import { useViewportMediaQuery } from 'hooks'
import ImportantList from 'components/BankAccountData/ImportantList';
import WireTransferServices from 'services/WireTransfer';
import UserInfoService from "services/AccountInfo/";
import { typeAccount } from 'config';
import { actionsType } from 'config/constants';
import {contact} from 'config/translate/variables'
import NewRelicService from 'services/NewRelic'
import BankAccountForm from './BankAccountForm';
import TagManagerService from 'services/TagManager';

let userInfo = {};
let actions = [];
let gtmChange = '';

const AddBankAccount = () => {
    const [typeBankSelected, setTypeBankSelected] = useState(null);
    const [typeAccountSelected, setTypeAccountSelected] = useState(null);
    const [listBank, setListBank] = useState(null);
    const [userAccount, setUserAccount] = useState({});
    const [bankAccountError, setBankAccountError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [cardNumberIsValid, setCardNumberIsValid] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [rutIsValid, setRutIsValid] = useState(false);
    const [rutValue, setRutValue] = useState('');
    const [rutData, setRutData] = useState('');
    const [email, setEmail] = useState('');
    const [cardValue, setCardValue] = useState('');
    const [checkbox, setCheck] = useState(false);
    const [nameTitular, setNameTitular] = useState('');
    let pathName = window.location.pathname;

    const isMobile = useViewportMediaQuery(768);
    useEffect(() => {
        _getListBank();
        init();
        gtmChange = false;
    }, []);

    const init = () => {
        UserInfoService.getUser().then(results => {
            userInfo = results;

            setEmail(userInfo.email);
            _getAccount()
        });
    }

    const _getAccount = () => {
        WireTransferServices.getAccount().then(account => {
            if(account && account.accountData) {
                gtmChange = true;
                setNameTitular(account.accountData.accountTitular);
                setRutData(account.accountData.accountDni);
                setUserAccount(account.accountData);
            } else {
                gtmChange = false;
                setUserAccount({});
                setNameTitular(userInfo.firstName + ' ' + userInfo.lastName);
                setRutData(userInfo.document);
            }
        });
    }
    const capitalizeText = (str) => {
        return str && str.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))
    }

    let bankNameD = userAccount ? capitalizeText(userAccount.bankName) : userAccount.bankName;

    useEffect(() => {
        if(listBank && userAccount) {
            setTypeBankSelected(listBank.filter((bank) => bank.label === bankNameD)[0])
        }

        if(typeAccount && userAccount) {
            setTypeAccountSelected(typeAccount.filter((type) => type.label === userAccount.accountType)[0])
        }

    }, [listBank, userAccount, typeAccount]);

    useEffect(() => {
        actions.push(PubSub.register('validate_toke_account_bank', () => accountSubmit(false)));

        
        if (cardNumberIsValid && rutIsValid && typeBankSelected && typeAccountSelected && checkbox && nameTitular) {
            setButtonDisabled(true);
        } else {
            setButtonDisabled(false);
        }

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, [cardNumberIsValid, rutIsValid, typeBankSelected, typeAccountSelected, checkbox, nameTitular])

    useEffect(() => {
        setCardValue(userAccount.accountNumber)
    }, [userAccount])

    useEffect(() => {
        validateCardNumber();
    }, [cardValue])

    const _getListBank = () => {
        WireTransferServices.listBank().then(results => {
            if(!(results && results.banks)) return null;

            setListBank(results.banks.map(bank => {
                return {
                    label: capitalizeText(bank.name),
                    value: bank.code
                }
            }));
        })
    }

    const _typeBank = (data) => {
        setTypeBankSelected(data);
    }

    const _typeAccount = (data) => {
        setTypeAccountSelected(data);
    }

    const rutValid = (valid, value) => {
        setRutIsValid(valid);
        setRutValue(value);
    }

    const validateCardNumber = () => {
        const validInput = cardValue;

        if(validInput && validInput.length > 3){
            setCardNumberIsValid(!!validInput);
            setBankAccountError(false);
            if(validInput.length > 17){
                setCardNumberIsValid(false);
                setBankAccountError(true);
            }
        } else {
            setCardNumberIsValid(false)
        }
    }

    const onCardChange = (e) => {
        const value = e.target.value;
        setCardValue(value);
        validateCardNumber();
    }


    const onChangeNameTitular = (e) => {
        const value = e.target.value;
        
        setNameTitular(value);
        
        
    }

    const onChangeInput = () => {
        setCheck(!checkbox)
    }
    
    const sendError = (error) => {
        setLoading(false);
        NewRelicService.sendPageAction({
            action: 'updateBankAccount',
            payload: error
        });
        setTimeout(() => {
            PubSub.dispatch('open_snackbar', {
                Subtitle: `<span class="snackbar-account-bank-error"> <i class="jumbo-icon-new-alert"/>Ocurrió un error, inténtalo más tarde</span>`,
                timer: 5000,
                type: 'addAccountBankError',
                className: 'snackbar-add-account-bank-message'
            });
        }, 0);
    }

    const sendMessageError = () => {
        setLoading(false);

        
        PubSub.dispatch('open_snackbar', {
            Subtitle: `<span class="snackbar-account-bank-error-rut">Ocurrió un error, comunícate con <strong>Servicio al cliente ${contact.phone}</strong></span>`,
            titleButtonMobile: 'Entendido',
            titleButtonDesktop: 'Entendido',
            type: 'addAccountBankErrorRut',
            className: 'snackbar-add-account-bank-message',
            callback: () => {
                if (typeof window !== 'undefined') window.location.reload();
            }
        });
    }

    const accountSubmit = (validateRut = true) => {
        setLoading(true);
        if(!(typeBankSelected?.value && cardValue && typeAccountSelected.label)) return false;
        const documentTitular = rutValue;

        if(userInfo?.document && (userInfo?.document !== documentTitular) && validateRut) {
            PubSub.dispatch(actionsType.MODAL.VALIDATION_CODE_CHECKOUT_OPEN, { email: email, genericValidate: true})
            setLoading(false);
            return
        }

        WireTransferServices.addAccount(typeBankSelected.value, cardValue, typeAccountSelected.label, nameTitular, documentTitular).then(data => {

            if(data.status === 200 && !(data.payload && data.payload.internalCode === "400-10")) {
                setLoading(false);
                _close();
                PubSub.dispatch(actionsType.GET_ACCOUNT_BANK_INFO, {data: data});
                if(gtmChange) {
                    TagManagerService.interaction('Step 2: datos bancarios modificados con éxito', pathName, 'Modificar datos cuenta bancaria')
                } else {
                    TagManagerService.interaction('Step 2: datos bancarios guardados con éxito', pathName, 'Agregar cuenta bancaria')
                }
                
                
            }else if(data.payload && data.payload.internalCode === "400-10"){
                sendMessageError(data.payload);
            } else {
                sendError(data.payload);
            }
        }).catch((e) => {
            sendError(e);
        })
    }

    const _close = () => {
        PubSub.dispatch('drawer_bank_account_close');
    }

    const bankAccountProps = {typeBankSelected, typeAccountSelected, _typeAccount, _typeBank, validateCardNumber, listBank, bankAccountError, rutValid, rutValue, email, rutData, userAccount, onCardChange, cardValue, checkbox, onChangeInput, onChangeNameTitular, nameTitular}

    return (
        <div className={'drawer-container'}>
            <h1 className="drawer-title">Datos para devolución de dinero</h1>

            <div className={'drawer-scroll'}>
                <ImportantList />
                <BankAccountForm {...bankAccountProps}/>
            </div>

            <div className="drawer-actions">
                {isMobile && <button className="secundary-btn" onClick={_close}>Hacerlo después</button>}
                <button className={(buttonDisabled ? ' primary-btn ' : ' disabled-btn ')} onClick={() => accountSubmit(true)}>
                    {loading && <div className="modal-bank-btn-loader"><Loader /></div>}
                    {!loading && <span>Guardar</span>}
                </button>
            </div>
        </div>
   
    );
}

export default AddBankAccount;